/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-08 10:21:40
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Modal, TextContainer, TextStyle, Link } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  active: boolean,
  removing: boolean,
  handleChange: () => void,
  handleContinue: () => void
};

type ComposedProps = Props & WithI18nProps & FormProps;

class ConfirmSwitchLayoutModal extends Component<ComposedProps> {
  render() {
    const { i18n, active } = this.props;

    return (
      <Modal
        open={active}
        onClose={this.handleChange}
        title={i18n.translate('AdminHTML.SwitchLayout.ConfirmSwitchLayout.title')}
        primaryAction={{
          content: i18n.translate('AdminHTML.SwitchLayout.ConfirmSwitchLayout.action_Back'),
          onAction: this.handleChange
        }}
        secondaryActions={[
          {
            content: i18n.translate('AdminHTML.SwitchLayout.ConfirmSwitchLayout.action_Continue'),
            onAction: this.handleContinue
          }
        ]}>
        <Modal.Section>
          <TextContainer>
            <TextStyle>
              {i18n.translate('AdminHTML.SwitchLayout.ConfirmSwitchLayout.content', {
                t1: (
                  <Link external url={URL['DuplicatingThemesDoc']}>
                    {i18n.translate('AdminHTML.SwitchLayout.ConfirmSwitchLayout.content_t1')}
                  </Link>
                )
              })}
            </TextStyle>
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }

  handleChange = () => {
    this.props.handleChange();
  };

  handleContinue = () => {
    const { handleContinue, data } = this.props;

    handleContinue(data);
  };
}

export default withI18n()(ConfirmSwitchLayoutModal);
